<template>
  <div class="fourth-step-box">
    <svg class="icon" aria-hidden="true">
      <use xlink:href="#icon-Frame1"></use>
    </svg>
    <!--您的交易对副本 {{`${$parent.currency}/USDT-${$parent.memo}`}} 已创建成功！-->
    <p>{{ $t('8000130', {currency: `${currencyFilter($parent.currency)}/USDT-${$parent.memo}`}) }}</p>
    <!--之后，关于该交易对的统计数据您可以前往WEB端官网的自由区页面中查看。-->
    <span class="inline-block success-tip">{{ $t('10000022') }}</span>
    <div class="precautions-content">
      <h3 class="bold">{{$t('8000194')}}</h3>
      <p>· {{$t('8000195')}}</p>
      <p>· {{$t('8000196')}}</p>
      <p>· {{$t('8000197')}}</p>
    </div>
    <div class="form-buttons-box">
      <van-button class="share-btn" :loading="posterLoading" @click="handleShare">{{ $t('8000178') }}</van-button>
      <van-button class="next-btn" @click="handleGoStatistics">{{ $t('10000021') }}</van-button>
    </div>
    <canvas id="myCanvas" width="340" height="327" style="display: none"></canvas>
    <div id="QRCode" ref="QRCode" v-show="false"></div>
  </div>
</template>

<script>
import {Button, Toast, Popup} from "vant";
import {getDomains, getCodesTion} from "../../../api/user";
import QRCode from "qrcodejs2";
import htmlCanvas from "html2canvas";
import freeZoneShareBgFa from '../../../assets/images/freeZoneShareBgFa.png'
import freeZoneShareBg from '../../../assets/images/freeZoneShareBg.png'

export default {
  name: "fourthStep",
  components: {
    vanButton: Button,
    vanPopup: Popup,
  },
  data() {
    return {
      shareModel: false,
      domains: '',
      invitationCode: '',
      imageBase64: '',
      hostName: '',
      loading: false,
      freeZoneShareBgFa: freeZoneShareBgFa,
      freeZoneShareBg: freeZoneShareBg,
      posterLoading: false
    }
  },
  created() {
    // this.getDomains()
    // this.getCodesTion()
    this.hostName = window.location.host
  },
  mounted() {
    this.getBase64Img(this.$parent.imgs)
  },
  methods: {
    currencyFilter(str) {
      return str.length > 9 ? `${str.slice(0,8)}.` : str
    },
    drawPoster() {
      const canvas = document.getElementById('myCanvas');
      const ctx = canvas.getContext('2d');
      const dpr = window.devicePixelRatio;
      const { width, height } = canvas;
      canvas.width = Math.round(width * dpr);
      canvas.height = Math.round(height * dpr);
      ctx.fillStyle = '#000000'; // 背景色可以是任何有效的 CSS 颜色值
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 绘制背景图
      const backgroundImage = new Image();
      backgroundImage.src = this.$parent.language == 'fa' ? `https://img.superex.live/static/images/freeZoon/freeZoneShareBgFa.png?timeStep=${new Date()}` : `https://img.superex.live/static/images/freeZoon/freeZoneShareBg.png?timeStep=${new Date()}`; // 背景图路径
      backgroundImage.setAttribute('crossOrigin', 'anonymous')
      backgroundImage.onload = () => {
        ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height)
        // 绘制文案1
        ctx.font = 'bold 14px Lato';
        ctx.scale(dpr, dpr);
        ctx.fillStyle = 'white';
        if (this.$parent.language == 'fa') {
          ctx.fillText(this.currencyFilter(this.$parent.currency), 306, 107);
        } else {
          ctx.fillText(this.currencyFilter(this.$parent.currency), 34, 107);
        }
        // 绘制文案2
        ctx.font = '10px Lato';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
        if (this.$parent.language == 'fa') {
          ctx.fillText(`${this.addressDesensitization(this.$parent.currencyAddress)} | ${this.$parent.memo}`, 328, 127);
        } else {
          ctx.fillText(`${this.$parent.memo} | ${this.addressDesensitization(this.$parent.currencyAddress)}`, 12, 127);
        }

        // 绘制文案3
        ctx.font = 'bold 14px Lato';
        ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
        if (this.$parent.language == 'fa') {
          ctx.fillText(this.$t('8000179'), 328, 147);
        } else {
          ctx.fillText(this.$t('8000179'), 12, 147);
        }

        // 绘制图标
        const iconImage = new Image();
        iconImage.src = `${this.$parent.imgs}?timeStep=${new Date()}`;
        iconImage.setAttribute('crossOrigin', 'anonymous')
        iconImage.onload = () => {
          if (this.$parent.language == 'fa') {
            ctx.drawImage(iconImage, 312, 95, 16, 16);
          } else {
            ctx.drawImage(iconImage, 12, 95, 16, 16);
          }
          // 绘制二维码
          const qrcodeImage = new Image();
          qrcodeImage.src = this.qrcodes['_el']['childNodes'][0].toDataURL('image/png', 1); // 替换为实际二维码图片路径
          qrcodeImage.setAttribute('crossOrigin', 'anonymous')
          qrcodeImage.onload = () => {
            if (this.$parent.language == 'fa') {
              ctx.drawImage(qrcodeImage, 18, 234, 75, 75);
            } else {
              ctx.drawImage(qrcodeImage, 247, 234, 75, 75);
            }
            const dataURL = canvas.toDataURL('image/png',1)
            this.posterLoading = !!dataURL
            if (this.$parent.isApp == 1) {
              this.$jsBridge.callHandler(this.$jsBridgeCmd.appFreeSharing, {
                url: `${this.domains}/lineDownload?language=${this.$parent.language}&currencyId=${this.$parent.currencyId}&memoId=${this.$parent.memoId}`,
                text: this.$t('8000181', {symbol: `${this.currencyFilter(this.$parent.currency)}/USDT`}),
                img: dataURL,
                title: this.$t('10000023',{currency: this.currencyFilter(this.$parent.currency)})
              }, (data) => {
              })
              this.posterLoading = false
            } else {
              const link = document.createElement('a');
              link.href = dataURL;
              link.download = this.$t('10000023',{currency: this.currencyFilter(this.$parent.currency)});
              link.click();
              this.posterLoading = false
            }
          };
        }
      }
    },
    getBase64Img(imageUrl) {
      fetch(imageUrl).then(response => response.blob()).then(blob => {
        // 创建FileReader对象
        const reader = new FileReader();
        reader.onload = e => {
          this.imageBase64 = e.target.result;
        };
        reader.readAsDataURL(blob);
      });
    },
    addressDesensitization(str) {
      if (str.length == 0) {
        return ''
      }
      var result = ''
      if (str.length > 14) {
        result = str.slice(0, 4) + "..." + str.slice(str.length - 4, str.length)
      } else {
        result = str
      }
      return result
    },
    // 生成二维码
    qrcode(domains) {
      let url = `${domains}/lineDownload?language=${this.$parent.language}&currencyId=${this.$parent.currencyId}&memoId=${this.$parent.memoId}`
      this.qrcodes = new QRCode('QRCode', {
        width: 76,
        height: 76, // 高度
        text: url, // 二维码内容
        render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        correctLevel: QRCode.CorrectLevel.L, //纠错级别，L表示最低
      })
    },
    handleClose() {
      document.getElementById('QRCode').innerHTML = ''
    },
    getDomains() {
      this.loading = true
      getDomains().then((res) => {
        this.domains = res.data
        this.qrcode(this.domains)
        this.loading = false
      })
    },
    getCodesTion() {
      getCodesTion().then((res) => {
        this.invitationCode = res.data.invitationCode
      })
    },
    handleShare() {
      this.posterLoading = true
      posthog.capture('Button Clicked', {
        trigger: 'h5_free_market_create_pair_comfirm_page_share_button',
        name: '创建交易对成功页面-去分享按钮-H5',
        pair: `${this.$parent.currency}_usdt`,
        instance: this.$parent.memo,
        currency_id: this.$parent.currencyId
      });
      this.drawPoster()
    },
    handleGoStatistics() {
      posthog.capture('Button Clicked', {
        trigger: 'h5_free_market_create_pair_comfirm_page_view_button',
        name: '创建交易对成功页面-去查看按钮-H5',
        pair: `${this.$parent.currency}_usdt`,
        instance: this.$parent.memo,
        currency_id: this.$parent.currencyId
      });
      if (this.$parent.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.appGetFreeConfig, {}, (data) => {
        })
      } else {
        this.$router.push('/download')
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/mixin";
@import "../../../assets/css/variableName";
@import "../public";

[dir='ltr'] {
  .share-main {
    background-image: url('../../../assets/images/freeZoneShareBg.png');
    background-color: black;

    .share-container {
      padding-left: torem(12);
    }

    .share-qrcode {
      position: absolute;
      right: torem(18.5);
      bottom: torem(18.5);
      z-index: 2;

      .loading-gif {
        width: torem(78);
        height: torem(78);
      }
    }
  }
}

[dir='rtl'] {
  .share-main {
    background-image: url('../../../assets/images/freeZoneShareBgFa.png');
    background-color: black;

    .share-container {
      padding-right: torem(12);
    }

    .share-qrcode {
      position: absolute;
      left: torem(18.5);
      bottom: torem(18.5);
      z-index: 2;

      .loading-gif {
        width: torem(76);
        height: torem(76);
      }
    }
  }
}

.fourth-step-box {
  padding: torem(32) torem(16) torem(100);
  text-align: center;

  svg.icon {
    width: torem(64);
    height: torem(64);
    margin: 0 auto torem(16);
  }

  p {
    font-size: torem(14);
    font-weight: 600;
    color: #000922;
    line-height: 1.5;
  }

  .success-tip {
    font-size: torem(12);
    line-height: 1.5;
    color: #7F8490;
    margin-top: torem(12);
  }
  .precautions-content{
    width: 100%;
    padding: torem(16);
    background-color: #F9F9F9;
    border-radius: torem(8);
    margin: torem(16) 0 0;

    h3{
      font-size: torem(14);
      color: #40475A;
      margin-bottom: torem(8);
      text-align: start;
    }
    p{
      font-size: torem(14);
      line-height: 1.5;
      color: #40475A;
      margin: 0;
      text-align: start;
      font-weight: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/compontents/freeZone/createSymbol/fourthStep.vue